enum CollectionEnum {
  Ad = 'Ad'
}

export default CollectionEnum;
